import { useSEO } from '@/hooks/useSEO';

export default function Privacy() {
  useSEO(
    'Privacy Policy | Earning Calculators.Com',
    'Read the Privacy Policy for Earning Calculators.Com.'
  );

  const lastUpdated = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  
  return (
    <div className="container mx-auto px-4 py-16">
      <div className="max-w-3xl mx-auto">
        <h1 className="font-headline text-4xl md:text-5xl font-bold tracking-tighter mb-6 text-center">
          Privacy Policy
        </h1>
        <div className="prose prose-lg mx-auto text-muted-foreground">
          <p><strong>Last Updated: {lastUpdated}</strong></p>
          <p>
            Earning Calculators.Com ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and share information when you use our website (the "Service").
          </p>
          <h2 className="font-headline text-3xl font-semibold tracking-tight mt-12 mb-4">Information We Collect</h2>
          <p>
            We do not collect any personal information from you when you use our calculators. All calculations are performed client-side within your browser. The data you enter into the calculators is not stored on our servers and is not transmitted to us.
          </p>
          <p>
            We may use standard analytics tools (like Google Analytics) to collect anonymous usage data to help us improve the Service. This data includes information such as browser type, pages visited, and time spent on the site, but it is not linked to any personally identifiable information.
          </p>
          <h2 className="font-headline text-3xl font-semibold tracking-tight mt-12 mb-4">How We Use Information</h2>
          <p>
            The anonymous data we collect is used solely for the purpose of understanding how our users interact with the Service, identifying popular tools, and improving the user experience. We do not sell or share this data with third parties for marketing purposes.
          </p>
          <h2 className="font-headline text-3xl font-semibold tracking-tight mt-12 mb-4">Cookies</h2>
          <p>
            We may use cookies to help with analytics and improve your experience. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
          </p>
          <h2 className="font-headline text-3xl font-semibold tracking-tight mt-12 mb-4">Changes to This Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
          </p>
        </div>
      </div>
    </div>
  );
}